import http from "./http";

function get_location_list(data) {
  return http.post(`locationList`, data);
}

function add_location(data) {
  return http.post(`savePoi`, data);
}

function delete_location(data) {
  return http.post(`delete_Location`, data);
}

function update_location(data) {
  return http.post(`update_Location`, data);
}

const LocationService = {
  get_location_list,
  add_location,
  delete_location,
  update_location,
};

export default LocationService;
// ====================================
